<template>
    <v-container style="padding-top: 80px !important">
        <div v-if="showcargando == true" id="cargando" style="z-index: 600;" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center">
            <div class="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row class="ma-1 ">
            <v-card width="100%" class="mx-2">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-card v-if="showcargando == false" elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="pa-5 pb-3 primary">
                <p style="color: white;">Asignación de Fianza</p>
            </v-card-title>
            <v-form ref="form" v-model="validForm" lazy-validation>
                <v-card-text>
                    <v-row justify="center">
                        <v-col cols="6" md="6">
                            <span class="type-label">Folio:</span>
                            <br>
                            <label class="typo__label font-weight-bold sub-Fia">
                                {{ this.datos.fifolio }}
                            </label>
                            <v-divider class="margin"></v-divider>
                            <span class="type-label">Afianzadora:</span>
                            <br>
                            <label class="typo__label font-weight-bold sub-Fia">
                                {{ this.datos.afnombre }}
                            </label>
                            <v-divider class="margin"></v-divider>
                            <span class="type-label">Responsable:</span>
                            <multiselect v-model="datosBusqueda.responsable"
                                deselect-label="No se puede remover el valor seleccionado" selected-label="Seleccionado"
                                select-label="Seleccionar valor" required :error-messages="validation.errorUsuario"
                                track-by="usuario" label="nombre" placeholder="Seleccionar Responsable"
                                :options="responsablesArray" :allow-empty="false">
                            </multiselect>
                            <span v-if="showResp" style="color: #FF5C93;"> Debes seleccionar un responsable </span>
                            <v-divider class="margin"></v-divider>
                            <span class="type-label">Fecha de alta:</span>
                            <v-dialog ref="dialog" outlined v-model="modal"
                                :return-value.sync="datosBusqueda.selectedDate" persistent width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <div class="date-align-center">
                                        <v-text-field v-model="datosBusqueda.selectedDate" label="" readonly outlined
                                            dense v-bind="attrs" v-on="on" :error-messages="validation.errorFecha"
                                            ref="datosBusqueda.selectedDate"></v-text-field>
                                    </div>
                                </template>
                                <v-date-picker v-model="datosBusqueda.selectedDate" locale="es-mx" :min="minfecha"
                                    :max="startdate" scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="secondary" @click="modal = false">
                                        Cancelar
                                    </v-btn>
                                    <v-btn text color="#536DFE" @click="$refs.dialog.save(datosBusqueda.selectedDate)">
                                        Aceptar
                                    </v-btn>
                                </v-date-picker>
                            </v-dialog>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn class="ma-2" color="#536DFE" @click="Asignar()">
                                <span class="color">Asignar</span>
                            </v-btn>
                            <v-btn class="ma-2" @click="limpiar()" color="default">
                                Limpiar
                            </v-btn>
                            <v-btn color="error" class="ma-2" v-on:click="cancelar()">
                                Cancelar
                            </v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-row>
                </v-card-text>
            </v-form>
        </v-card>
    </v-container>
</template>
<script>

import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import { mapState } from "vuex";
import DataTable from "@/components/pages/DataTableNet/DataTable";
import Menu from '@/components/pages/Contraloria/MenuRecuperaciones/MenuRecup.vue';
import Fianzas from '@/services/Fianzas/fianzas.service.js';
import moment from "moment";

export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        DataTable,
        Menu
    },
    data() {
        return {
            datosBusqueda: {
                monto: null,
                responsable: null,
            },
            validForm: true,
            minfecha: '',
            startdate: '',
            showcargando: true,
            validation: {
                errorUsuario: '',
            },
            responsablesArray: [],
            //Alta
            modal: false,
            showResp: false,
            datos: null,
            permisoAsignar: false
        }
    },
    watch: {
        'datosBusqueda.responsable'(val) {
            this.showResp = false;
        },
    },
    computed: {
        ...mapState(["domain", "informationPage", "permission"]),
    },
    methods: {
        limpiar() {
            this.datosBusqueda.responsable = null
            let today = new Date().toJSON().slice(0, 10);
            this.datosBusqueda.selectedDate = today;
            this.showResp = false;
        },
        async Asignar() {
            var errorCounter = 0;
            if (this.datosBusqueda.responsable == null) {
                this.validation.errorUsuario = 'Seleccione una opción';
                this.showResp = true;
                errorCounter++;
            }
            if (errorCounter == 0) {
                this.$swal({
                    position: 'center',
                    title: 'Guardando datos...',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: async () => {
                        this.$swal.showLoading();
                        let formData = new FormData();
                        formData.append("responsable", this.datosBusqueda.responsable.usuario);
                        formData.append("fecha", this.datosBusqueda.selectedDate);
                        formData.append("afclave", this.datos.afclave);
                        formData.append("fifolio", this.datos.fifolio);
                        let data = await Fianzas.AsignarFianza(formData);
                        if (data) {
                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Se asignó la fianza correctamente',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                timer: 2500,
                            }).then(async () => {
                                await MetodosGenerales.guardarEnSesionInfoReporte(this.datos, 'fianza');
                                this.$router.push({ name: 'DetalleFianza' }).catch((error) => error);
                            });
                        }
                        else {
                            this.$swal({
                                position: 'center',
                                icon: 'error',
                                title: 'Error',
                                text: 'Ocurrió un error, al asignar la fianza, intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                            })
                        }
                    }
                });
            }
        },
        async cancelar() {
            await MetodosGenerales.guardarEnSesionInfoReporte(this.datos, 'fianza');
            this.$router.push({ name: 'DetalleFianza' }).catch((error) => error);
        }
    },
    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", "15,317,22").then((response) => {
            if (response.data.length > 0) {
                response.data.forEach(permiso => {
                    if (permiso.peclave == 15)//acceso al módulo de contraloría Normativa 
                        this.permisoContraloria = true;
                    if (permiso.peclave == 317)//Permiso para fianzas
                        this.permisoFianzas = true;
                    if (permiso.peclave == 22)//Permiso para fianzas
                        this.permisoAsignar = true;
                })

                if (!this.permisoContraloria || !this.permisoFianzas || !this.permisoAsignar) {
                    this.$router.push({ name: `NoAutorizado` }).catch((error) => error);
                }
            } else {
                this.$router.push({ name: `NoAutorizado` }).catch((error) => error);
            }
        });
    },
    async mounted() {
        let datosFianza = await MetodosGenerales.obtenerSessionReporte('fianza');
        this.datos = datosFianza;
        this.responsablesArray = await Fianzas.ObtenerResponsables();
        let today = new Date().toJSON().slice(0, 10);
        this.startdate = today;
        this.minfecha = moment(today).subtract(3, 'days').format('YYYY-MM-DD');
        this.datosBusqueda.selectedDate = today;
        this.showcargando = false;
    },
}
</script>

<style scoped>
.sub-Fia {
    font-size: 18px;
}

.margin {
    margin: 2vh 0;
}

.color {
    color: white
}
</style>
